import React, { Component } from "react";

export default class LanguageComprehension extends Component {
  render() {
    var {
      comprehension_question_1,
      comprehension_question_2,
      comprehension_question_3,
      comprehension_question_4,
      comprehension_question_5,
      comprehension_question_6,
      comprehension_question_7,
      comprehension_question_8,
      language_comprehension_score,
      comprehension_question_checkbox_1,
      comprehension_question_checkbox_2,
      comprehension_question_checkbox_3,
      comprehension_question_checkbox_4,
      comprehension_question_checkbox_5,
      comprehension_question_checkbox_6,
      comprehension_question_checkbox_7,
      comprehension_question_checkbox_8,
    } = this.props.data;
    return (
      <div className="row p-3 border border-dark bg-white">
        <div className="col-lg-12">
          <div className="row mt-4">
            <div className="col-lg-6">
              <div className="d-flex">
                <span className="fs-19 mb-3">1. Something you wear </span>{" "}
              </div>
              <input
                value={comprehension_question_1}
                name="comprehension_question_1"
                type="text"
                className="ecas-input-field"
              />
            </div>
            <div className="col-lg-6">
              <div className="d-flex">
                <span className="fs-19">
                  2. An animal with {this.props.language === "en-uk" ? "colourful" : "colorful"} feathers{" "}
                </span>{" "}
              </div>
              <input
                value={comprehension_question_2}
                name="comprehension_question_2"
                type="text"
                className="ecas-input-field"
              />
            </div>
            <div className="col-lg-6">
              <div className="d-flex">
                <span className="fs-19 mb-3">3. Something you play </span>{" "}
              </div>
              <input
                value={comprehension_question_3}
                name="comprehension_question_3"
                type="text"
                className="ecas-input-field"
              />
            </div>
            <div className="col-lg-6">
              <div className="d-flex">
                <span className="fs-19 mb-3">4. {this.props.language =="en-uk" ? "A means of transport" : "A means of transportation"} </span>{" "}
              </div>
              <input
                value={comprehension_question_4}
                name="comprehension_question_4"
                type="text"
                className="ecas-input-field"
              />
            </div>
            <div className="col-lg-6">
              <div className="d-flex">
                <span className="fs-19 mb-3">5. Something a plumber might use </span>{" "}
              </div>
              <input
                value={comprehension_question_5}
                name="comprehension_question_5"
                type="text"
                className="ecas-input-field"
              />
            </div>
            <div className="col-lg-6">
              <div className="d-flex">
                <span className="fs-19 mb-3">
                  6. Something that rolls into a ball{" "}
                </span>{" "}
              </div>
              <input
                value={comprehension_question_6}
                name="comprehension_question_6"
                type="text"
                className="ecas-input-field"
              />
            </div>
            <div className="col-lg-6">
              <div className="d-flex">
                <span className="fs-19 mb-3">7. Something used on a farm </span>{" "}
              </div>
              <input
                value={comprehension_question_7}
                name="comprehension_question_7"
                type="text"
                className="ecas-input-field"
              />
            </div>
            <div className="col-lg-6">
              <div className="d-flex">
                <span className="fs-19 mb-3">
                  8. Something that lives in the African savannah{" "}
                </span>{" "}
              </div>
              <input
                value={comprehension_question_8}
                name="comprehension_question_8"
                type="text"
                className="ecas-input-field"
              />
            </div>
          </div>
          <hr style={{ marginBottom: 29 }} />

          <div className="pl-0 col-lg-6 text-left">
            <span className="fs-19">Score (0-8) </span>
            <input
              type="number"
              name="language_comprehension_score"
              readOnly=""
              className="ecas-input-field"
              placeholder="Score"
              value={language_comprehension_score}
            />
          </div>
        </div>
      </div>
    );
  }
}
